export default __webpack_public_path__ + "static/fondo-material-d4f905ec9aec772785ef50cbe63f07c3.webp";